import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import { messages } from '../messages';

const State = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));

  const { fulfillmentPlanId } = fulfillment;

  const fulfillmentPlan = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) || {};

  const { salesOrdersFulfilledIds } = fulfillmentPlan;

  const [salesOrderId] = salesOrdersFulfilledIds ?? [];

  const [shipTo] =
    useSelector((state) =>
      Global.selectEntitiesSalesOrderProperty(state, {
        salesOrderId,
        property: 'shipTos',
      }),
    ) ?? [];

  return shipTo?.state ?? '';
};

State.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const state = {
  getMessageDescriptor: () => messages.state,
  name: <FormattedMessage {...messages.state} />,
  id: 'state',
  render: (data) => <State fulfillmentId={data.id} />,
};
